import { render, staticRenderFns } from "./FloatingSearchBar.vue?vue&type=template&id=1ed386d2&lang=pug"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports